module.exports = __webpack_public_path__ + "img/i-1.c6722e4d.svg";